module.exports = __webpack_public_path__ + "static/media/1.9db3e347.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/1.png
// module id = 1447
// module chunks = 0